import Vue from 'vue';
import VueRouter from 'vue-router';
import Navigation from '../components/Navigation.vue';
import Preview from '../components/Preview.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/admin/login',
        name: 'Login',
        components: {
            default: () =>
                import(/* webpackChunkName: "login" */ '../views/Login.vue'),
            navigation: false,
            preview: false,
        },
    },
    {
        path: '/admin/forgot-password',
        name: 'Forgot Password',
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "forgot-password" */ '../views/ForgotPassword.vue'
                ),
            navigation: false,
            preview: false,
        },
    },
    {
        path: '/admin/reset-password',
        name: 'Reset Password',
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "reset-password" */ '../views/ResetPassword.vue'
                ),
            navigation: false,
            preview: false,
        },
    },
    {
        path: '/admin/register',
        name: 'Register',
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "register" */ '../views/Register.vue'
                ),
            navigation: false,
            preview: false,
        },
    },
    {
        path: '/admin/register/:organisationslug',
        name: 'RegisterOrg',
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "register" */ '../views/Register.vue'
                ),
            navigation: false,
            preview: false,
        },
    },
    {
        path: '/admin',
        name: 'Organisation',
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "organisation" */ '../views/Organisation.vue'
                ),
            navigation: Navigation,
            preview: false,
        },
    },
    {
        path: '/admin/tree/new',
        name: 'New Tree',
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "appearance" */ '../views/Appearance.vue'
                ),
            navigation: Navigation,
            preview: Preview,
        },
    },
    {
        path: '/admin/tree/:treeslug/links',
        name: 'Links',
        components: {
            default: () =>
                import(/* webpackChunkName: "links" */ '../views/Links.vue'),
            navigation: Navigation,
            preview: Preview,
        },
        meta: {
            title: 'Links',
        },
    },
    {
        path: '/admin/tree/:treeslug/appearance',
        name: 'Appearance',
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "appearance" */ '../views/Appearance.vue'
                ),
            navigation: Navigation,
            preview: Preview,
        },
        meta: {
            title: 'Appearance',
        },
    },
    {
        path: '/admin/tree/:treeslug/settings',
        name: 'Settings',
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "settings" */ '../views/Settings.vue'
                ),
            navigation: Navigation,
            preview: Preview,
        },
        meta: {
            title: 'Settings',
        },
    },
    {
        path: '/admin/tree/:treeslug/reports',
        name: 'Reports',
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "reports" */ '../views/Reports.vue'
                ),
            navigation: Navigation,
            preview: false,
        },
        meta: {
            title: 'Reports',
        },
    },
    {
        path: '/admin/users',
        name: 'Users',
        components: {
            default: () =>
                import(/* webpackChunkName: "users" */ '../views/Users.vue'),
            navigation: Navigation,
            preview: false,
        },
    },
    {
        path: '/:treeslug',
        name: 'ImageView',
        components: {
            default: () =>
                import(
                    /* webpackChunkName: "imageView" */ '../views/ImageView.vue'
                ),
            navigation: false,
            preview: false,
        },
        meta: {
            title: 'Image View',
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
